export const deClientPortalValueCheckPageLayout = {
    sectionLabel: 'BEWERTUNG',
    overviewMetricGrid: {
        changeFromPreviousValuation: 'Veränderung zum Vorgutachten',
        mortgageLendingValueComparisonLabel: 'BelWert',
    },
    baseValuationWidget: {
        title: 'Zugrundeliegendes Gutachten',
    },
    tenantSummaryWidget: {
        categoryLabel: 'Kategorie',
        baseLabel: 'Basis',
        groupLabels: {
            rentable: 'vermietbar',
            rented: 'vermietet',
            vacant: 'leerstand',
        },
        rowLabels: {
            area: 'Flächen',
            units: 'Einheiten',
            parkingSpaces: 'Stellplätze',
        },
    },
    marketDataWidget: {
        existingRents: 'Mieten Bestand',
    },
    landMarketDataWidget: {
        title: 'Grundstücksmarktberichte',
    },
}
